import Loader from 'components/Loader';
import React from 'react';

type AsyncContainerProps = {
   loading: boolean;
   children: React.ReactNode;
};

const AsyncContainer = ({loading, children}: AsyncContainerProps) => {
   if (loading) {
      return <Loader />;
   }
   return <>{children}</>;
};

export default AsyncContainer;
